export default "__VITE_ASSET__DQHPUoy9__"